import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { AutoCountTextControl } from "appworks/ui/controls/standard/text/auto-count-text-control";
import { ControlFactory } from "../control-factory";

export class AutoCountTextControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        if (layer.getFlexiText("autoplay_count")) {
            return true;
        }
        return false;
    }

    public build(layer: Layers): AbstractControl[] {
        return [ new AutoCountTextControl(layer.getFlexiText("autoplay_count")) ];
    }
}
